/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_user">;
    readonly " $refType": "SbRespRefineMenuSelector_user";
};
export type SbRespRefineMenuSelector_user$data = SbRespRefineMenuSelector_user;
export type SbRespRefineMenuSelector_user$key = {
    readonly " $data"?: SbRespRefineMenuSelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuSelector_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'ee7af77e836745da5513d2f7f4f23534';
export default node;
